export default "__VITE_ASSET__DRzFyiuT__"